module.exports = __webpack_public_path__ + "static/media/Snapshot Vid Script 08 2024_1726657209417.15a44ca2.pdf";